import { dateFormat, formatDateTime } from "../../../../../utils/dateFormat";

export const approveDetails = (object) => {
  const {
    firstName: requestorFirstName,
    middleName: requestorMiddleName,
    lastName: requestorLastName,
    affiliate,
    branch,
  } = object.requestor || {};

  return [
    {
      label: "Approved By",
      value: object?.approveDetails?.approvedBy,
    },
    {
      label: "Date Approved",
      value: formatDateTime(object?.approveDetails?.dataApproved),
    },
    {
      label: "Affiliate",
      value: object?.approveDetails?.affiliate || "",
    },
    {
      label: "Branch",
      value: object?.approveDetails?.branch || "",
    },
    {
      label: "Remarks",
      value: object?.approveDetails?.remarks || "",
    },
  ];
};
